<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
{{ username }}
<button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5 p-0 d-flex jc-c align-items-center">
  <img src="{{ path }}" alt="user" class="profile-pic" />
</button>
<mat-menu #profile="matMenu" class="mymegamenu">
  <button mat-menu-item><mat-icon>account_box</mat-icon> Profile</button>

  <button mat-menu-item (click)="logout()"><mat-icon>exit_to_app</mat-icon> Sign Out</button>
</mat-menu>
